<template>
  <div id="home" ref="home">
    <!-- -----------------------------banner轮播 ---------------------->
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <el-row class="slideItem">
            <!-- 移动端手机显示 -->
            <el-col :xs="24" class="hidden-sm-and-up rightImg">
              <img v-lazy="banner1" alt="" />
            </el-col>
            <el-col
              :xs="24"
              :sm="12"
              :md="12"
              :lg="12"
              :xl="12"
              class="leftTxt wow fadeInUp"
            >
              <h1 class="hi">hi,</h1>
              <h1 class="welcome">{{$t('home.welcome')}}！</h1>
              <div class="welTxt">
                {{$t('home.bannerWords')}}
              </div>
              <div class="btnRow">
                <div class="btn aboutBtn" @click="goAbout()">{{$t('home.aboutBtn')}}</div>
                <div class="btn linkBtn" @click="toBottom()">{{$t('home.contactBtn')}}</div>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :sm="11"
              :md="11"
              :lg="11"
              :xl="11"
              class="hidden-xs-only rightImg"
              :offset="1"
            >
              <img v-lazy="banner1" alt="" />
            </el-col>
          </el-row>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
    </div>
    <!-- ----------------我们的产品----------------------------- -->
    <div class="weProduct">
      <div class="topPart">
        <h2 class="title">消防产品业务</h2>
        <div class="intro">
          以智慧消防系统为核心，从设备感知、人员管理、视觉辅助等多个角度，全面适应客户不同应用场景
        </div>
      </div>
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <div class="itemWrap item1 wow animate__zoomIn" @click="goProduct(1)">
            <div class="imgIcon"></div>
            <div class="title">智慧消防</div>
            <div class="itemIntro wow fadeInUp">
              各类消防数据融合，全方位保护消防安全
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <div class="itemWrap item2 wow animate__zoomIn" @click="goProduct(2)">
            <div class="imgIcon"></div>
            <div class="title">智慧用电</div>
            <div class="itemIntro wow fadeInUp">
              多维度监测用电数据，提前识别风险隐患
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <div class="itemWrap item3 wow animate__zoomIn" @click="goProduct(3)">
            <div class="imgIcon"></div>
            <div class="title">独立感知</div>
            <div class="itemIntro wow fadeInUp">
              无需布线、无需电源，快速部署消防报警监控
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <div class="itemWrap item4 wow animate__zoomIn" @click="goProduct(4)">
            <div class="imgIcon"></div>
            <div class="title">智慧巡检</div>
            <div class="itemIntro wow fadeInUp">
              移动端扫码巡检，管控日常消防工作
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <div class="itemWrap item6 wow animate__zoomIn" @click="goProduct(5)">
            <div class="imgIcon"></div>
            <div class="title">视频RTC</div>
            <div class="itemIntro wow fadeInUp">
              AI人工智能自动识别烟火、入侵情况
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
          <div class="itemWrap item5 wow animate__zoomIn" @click="goProduct(6)">
            <div class="imgIcon"></div>
            <div class="title">视频识别</div>
            <div class="itemIntro wow fadeInUp">
              兼容不同品牌视频设备，快速统一接入
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--------------------- 我们的技术支持------------------------- -->
    <div class="weTech">
      <el-row>
        <el-col :xs="24" :sm="15" :md="15" :lg="15" :xl="15" align="left">
          <img src="../../assets/img/home/tech.png" alt="" />
        </el-col>
        <el-col :xs="24" :sm="9" :md="9" :lg="9" :xl="9">
          <swiper :options="swiperOption2" ref="mySwiper2">
            <swiper-slide>
              <div class="itemTech">
                <h2 class="title2">全方位多领域技术应用</h2>
                <div class="content">
                  铁辰智慧消防系统综合利用物联网、云计算、数据融合、大数据存储、数据挖掘、人工智能等前沿技术，与消防行业实际业务需求相结合，以物防、人防加技防的手段辅助消防工作，打造数字化、全面化、智慧化的消防管理体系。
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </el-col>
      </el-row>
    </div>
    <!-- --------------------我们的目标----------------------------------- -->
    <div class="weGoal">
      <div class="logoWord">补强物防，监管人防，打造技防</div>
    </div>

    <!-- ---------------------成功案例 ------------------------------------->
    <div class="weCase">
      <div class="topPart">
        <h2 class="title">成功案例</h2>
      </div>
      <el-row :gutter="30">
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
          v-for="(item, index) in caseInfoArr"
          :key="index"
        >
          <div class="caseItem" @click="goCaseDetail(index + 1)">
            <img :src="item.src" alt="" class="caseImg" />
            <div class="overlay"></div>
            <div class="caseTime">建成时间：{{ item.date }}</div>
            <div class="bottomInfo">
              <div class="caseName">{{ item.name }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import banner1 from "../../assets/img/home/banner1.png";
export default {
  props: {},
  data() {
    return {
      banner1,
      swiperOption: {
        loop: false,
        autoplay: false,
        // {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
      swiperOption2: {
        loop: false,
        autoplay: false,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: false, //允许分页点击跳转
        },
      },
      carouselArr: [
        {
          src: banner1,
        },
      ],
      caseInfoArr: [
        {
          name: "高铁南京南站",
          date: "2018年",
          src:require('../../assets/img/home/njn.png')
        },
        {
          name: "杭甬高速铁路",
          date: "2019年",
          src:require('../../assets/img/home/hyx.png')
        },
        {
          name: "南京动车段",
          date: "2020年-2021年",
          src:require('../../assets/img/home/dcd.png')
        },
        {
          name: "南京电务段",
          date: "2018年",
          src:require('../../assets/img/home/dwd.png')
        },
        {
          name: "南京桥工段",
          date: "2019年",
          src:require('../../assets/img/home/qgd.png')
        },
        {
          name: "吉美思物联网产业园",
          date: "2020年-2021年",
          src:require('../../assets/img/home/jms.png')
        },
      ],
    };
  },
  computed: {},

  created() {},
  mounted() {
    new WOW({ live: false}).init();
  },
  watch: {},
  methods: {
    goProduct(type) {
      this.$router.push({
        name: "product",
        params: {
          category: type,
        },
      });
    },
    goAbout() {
      this.$router.push({ name: "about" });
    },
    toBottom() {
      let height = document.body.clientHeight;
      window.scroll({ top: height, left: 0, behavior: "smooth" });
    },
    goCaseDetail(type) {
      this.$router.push({
        name: "case",
        params: {
          category: type,
        },
      });
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

<style lang="scss">
#home {
  .banner {
    padding-top: 3rem;
    padding: 3% 14%;
  }
  .swiper-wrapper {
    margin-bottom: 6rem;
  }
  .slideItem {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .leftTxt {
      .welcome {
        margin: 2rem 0 4rem;
        color: #333;
      }
      .hi {
        color: #333;
      }
      .welTxt {
        color: #666666;
        font-size: 1.4rem;
        line-height: 2.4rem;
        width: 90%;
        text-align: justify;
        text-justify: inter-ideograph; /*IE*/
      }
      .btnRow {
        margin-top: 6rem;
        .btn {
          display: flex;
          width: 21%;
          height: 4rem;
          justify-content: center;
          align-items: center;
          border-radius: 30px;
          border: none;
          font-size: 1.6rem;
          float: left;
          margin: 2rem 2rem 2rem 0;
          cursor: pointer;
          letter-spacing: 2px;
        }
        .aboutBtn {
          background: linear-gradient(
            125deg,
            rgba(0, 183, 164, 0.8),
            rgba(13, 202, 129, 0.8)
          );
          box-shadow: 8px 8px 20px 0px rgba(8, 194, 142, 0.24);
          font-weight: bold;
          color: #ffffff;
        }
        .linkBtn {
          font-weight: bold;
          color: #00b7a4;
          border: 2px solid #06c094;
          background: #ffffff;
        }
      }
    }
    .rightImg {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .topPart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      color: #333333;
      margin-bottom: 15px;
    }
    .intro {
      width: 60%;
      color: #696969;
      font-size: 1.4rem;
      line-height: 2.2rem;
      text-align: center;
    //   text-justify: inter-ideograph; /*IE*/
    }
  }
  .weProduct {
    padding: 5% 14%;
    .itemWrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      width: 100%;
      height: 35rem;
      border-radius: 8px;
      margin-bottom: 4rem;
      padding: 3rem;
      position: relative;
      &:hover {
        .title {
          color: #ffffff;
        }
        .itemIntro {
          color: #ffffff;
        }
      }
      img {
        width: 4rem;
        height: 5rem;
        margin: 2rem 0;
      }
      .imgIcon {
        width: 5rem;
        height: 5rem;
        margin: 2rem 0;
        background-position: center;
        background-size: 100% 100%;
      }
      .title {
        font-size: 1.6rem;
        color: #333333;
        font-weight: bold;
        line-height: 4rem;
        margin: 1rem 0 4rem;
      }
      .itemIntro {
        font-size: 1.4rem;
        color: #696969;
        line-height: 2.2rem;
        text-align: justify;
        text-justify: inter-ideograph; /*IE*/
      }
    }

    .item1 {
      .imgIcon {
        background-image: url("../../assets/img/home/xiaofang.svg");
      }

      &:hover {
        background-image: url("../../assets/img/home/zhxf.png");
        background-position: center;
        background-size: 100% 100%;
        .imgIcon {
          background-image: url("../../assets/img/home/xiaofang2.svg");
        }
      }
    }
    .item2 {
      .imgIcon {
        background-image: url("../../assets/img/home/yongdian.svg");
      }
      &:hover {
        background-image: url("../../assets/img/home/zhyd.png");
        background-position: center;
        background-size: 100% 100%;
        .imgIcon {
          background-image: url("../../assets/img/home/yongdian2.svg");
        }
      }
    }
    .item3 {
      .imgIcon {
        background-image: url("../../assets/img/home/ganzhi.svg");
      }
      &:hover {
        background-image: url("../../assets/img/home/dlgz.png");
        background-position: center;
        background-size: 100% 100%;
        .imgIcon {
          background-image: url("../../assets/img/home/ganzhi2.svg");
        }
      }
    }
    .item4 {
      .imgIcon {
        background-image: url("../../assets/img/home/xunjian.svg");
      }
      &:hover {
        background-image: url("../../assets/img/home/zhxj.png");
        background-position: center;
        background-size: 100% 100%;
        .imgIcon {
          background-image: url("../../assets/img/home/xunjian2.svg");
        }
      }
    }
    .item5 {
      .imgIcon {
        background-image: url("../../assets/img/home/rtc.svg");
      }
      &:hover {
        background-image: url("../../assets/img/home/spsb.png");
        background-position: center;
        background-size: 100% 100%;
        .imgIcon {
          background-image: url("../../assets/img/home/rtc2.svg");
        }
      }
    }
    .item6 {
      .imgIcon {
        background-image: url("../../assets/img/home/shibie.svg");
      }
      &:hover {
        background-image: url("../../assets/img/home/rtc.png");
        background-position: center;
        background-size: 100% 100%;
        .imgIcon {
          background-image: url("../../assets/img/home/shibie2.svg");
        }
      }
    }
  }

  .weTech {
    background: #f6f8fa;
    padding: 5% 14%;
    img {
      height: 40rem;
      width: 80%;
      object-fit: contain;
    }
   
    .itemTech {
      height: 40rem;
      padding: 1rem;
      display: flex;
    flex-direction: column;
    justify-content: center;
      .title2 {
        color: #333333;
        line-height: 5rem;
        font-size: 2.6rem;
        margin-bottom: 3rem;
      }
      .content {
        font-size: 1.4rem;
        color: #777777;
        line-height: 2.8rem;
        text-align: justify;
        text-justify: inter-ideograph; /*IE*/
      }
    }
    
  }
  .weGoal {
    background-image: url("../../assets/img/home/homebg.png");
    background-position: center;
    background-size: cover;
    height: 45rem;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    .logoWord{
        font-weight: bold;
        color: #FFFFFF;
        font-size: 5rem;
    }
  }
  .weCase {
    background: #f6f8fa;
    padding: 5% 14%;
    .caseItem {
      position: relative;
      height:26rem;
      margin-bottom: 4rem;
      overflow: hidden;
      cursor: pointer;
      &:hover {
        .overlay {
          height: 82%;
          opacity: 1;
          transform: scale(1.1);
        }
        .caseImg {
          height: 82%;
          transform: scale(1.1);
        }
      }
      .overlay {
        position: absolute;
        width: 100%;
        height: 86%;
        top: 0;
        left: 0;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 0;
        z-index: 2;
        transition: all 0.5s;
      }
      .caseImg {
        height: 86%;
        width: 100%;
        border-radius: 1rem 1rem 0 0;
        position: absolute;
        top: 0;
        left: 0;
        transition: all 0.5s;
        object-fit: cover;
      }
      .caseTime {
        background: linear-gradient(125deg, #00b7a4, #0dca81);
        border-radius: 4px 0px 4px 0px;
        color: #ffffff;
        font-size: 1.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        height: 4rem;
        widows: 16rem;
        padding: 1rem 2rem;
      }
      .bottomInfo {
          position:absolute;
          bottom: 0;
        .caseName {
          font-size: 1.8rem;
            font-weight: bold;
          color: #333333;
        }
      }
    }
  }
}
@import '../../assets/responsive/home.scss'
</style>
